<template>
  <div class="page-container">
    <h1 class="page-title">纠纷处理</h1>
    
    <div class="content-section">
      <h2 class="section-title">纠纷处理原则</h2>
      <p class="section-text">
        新疆音线平台致力于为用户提供公正、透明、高效的纠纷解决机制。我们秉持"公平公正、实事求是、及时处理"的原则，确保各方权益得到合理保障。
      </p>
    </div>
    
    <div class="content-section">
      <h2 class="section-title">纠纷处理流程</h2>
      <ol class="process-list">
        <li>
          <strong>提交申请：</strong>用户可通过平台内的"纠纷处理"入口或客服联系方式提交纠纷处理申请，需详细说明纠纷发生的时间、地点、相关人员及具体情况。
        </li>
        <li>
          <strong>受理确认：</strong>平台将在收到申请后1-3个工作日内进行初步审核，并通知申请人是否受理该纠纷。
        </li>
        <li>
          <strong>调查取证：</strong>平台将对纠纷相关情况进行全面调查，包括但不限于查阅系统记录、收集相关证据、联系相关方了解情况等。
        </li>
        <li>
          <strong>调解协商：</strong>平台将组织相关方进行调解协商，寻求各方都能接受的解决方案。
        </li>
        <li>
          <strong>处理决定：</strong>如调解未果，平台将根据平台规则和相关法律法规作出处理决定。
        </li>
        <li>
          <strong>执行落实：</strong>平台将监督处理决定的执行落实情况，确保纠纷得到有效解决。
        </li>
      </ol>
    </div>
    
    <div class="content-section">
      <h2 class="section-title">纠纷类型及处理方式</h2>
      <div class="dispute-types">
        <div class="dispute-item">
          <h3 class="dispute-title">账号纠纷</h3>
          <p class="dispute-desc">
            包括账号归属、账号被盗、账号封禁等纠纷。平台将核实账号所有权，并根据实际情况协助用户找回账号或解除不当封禁。
          </p>
        </div>
        
        <div class="dispute-item">
          <h3 class="dispute-title">交易纠纷</h3>
          <p class="dispute-desc">
            包括虚拟物品交易、打赏退款等纠纷。平台将根据交易记录和相关证据，判断交易是否存在问题，并作出相应处理。
          </p>
        </div>
        
        <div class="dispute-item">
          <h3 class="dispute-title">内容纠纷</h3>
          <p class="dispute-desc">
            包括内容侵权、不当内容举报等纠纷。平台将根据相关法律法规和平台规则，对内容进行审核，并作出下架或保留的决定。
          </p>
        </div>
        
        <div class="dispute-item">
          <h3 class="dispute-title">用户行为纠纷</h3>
          <p class="dispute-desc">
            包括用户间互动冲突、骚扰举报等纠纷。平台将根据聊天记录和行为日志，判断是否存在违规行为，并对违规用户进行相应处罚。
          </p>
        </div>
      </div>
    </div>
    
    <div class="content-section">
      <h2 class="section-title">联系方式</h2>
      <p class="section-text">
        纠纷处理邮箱：2756825623@qq.com<br>
        客服电话：15160945581<br>
        工作时间：周一至周五 9:00-18:00（法定节假日除外）
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DisputeResolution'
}
</script>

<style scoped>
.page-container {
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;
  padding-bottom: 40px;
}

.page-title {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 30px;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.content-section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 15px;
  color: #333;
}

.section-text {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  margin-bottom: 15px;
  text-align: justify;
}

.process-list {
  padding-left: 20px;
  margin-bottom: 15px;
}

.process-list li {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  margin-bottom: 15px;
  text-align: justify;
}

.dispute-types {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.dispute-item {
  background-color: #f9f9f9;
  border-radius: 4px;
  padding: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.dispute-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
  color: #4169e1;
}

.dispute-desc {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  text-align: justify;
}

@media (max-width: 768px) {
  .dispute-types {
    grid-template-columns: 1fr;
  }
}
</style> 